"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/typography/style/css");

var _typography = _interopRequireDefault(require("antd/es/typography"));

require("antd/es/popconfirm/style/css");

var _popconfirm = _interopRequireDefault(require("antd/es/popconfirm"));

var _react = _interopRequireWildcard(require("react"));

var _EditableRow = _interopRequireDefault(require("./EditableRow"));

var _EditableCell = _interopRequireDefault(require("./EditableCell"));

var _lodash = _interopRequireWildcard(require("lodash"));

require("./editableTable.scss");

var _UnsavedLeavingGuard = _interopRequireDefault(require("../util/UnsavedLeavingGuard"));

var _reactRouter = require("react-router");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class EditableTable extends _react.Component {
  constructor(props) {
    super(props);

    this.save = key => {
      const row = this.state.dataSource.find(u => u.key === key);

      if (this.state.isUnsaved && !!row && this.props.handleSave) {
        this.props.handleSave(row);
      }

      this.setState({
        editingKey: '',
        previousVersion: undefined,
        isUnsaved: false
      });
    }; // Updates data in state


    this.handleSaveCell = row => {
      if (this.state.dataSource) {
        const newData = [...this.state.dataSource];
        const index = newData.findIndex(item => row.key === item.key);
        const item = newData[index];

        if (!_lodash.default.isEqual(item, row)) {
          newData.splice(index, 1, { ...item,
            ...row
          });
          this.setState({
            dataSource: newData,
            isUnsaved: true
          });
        }
      }
    };

    this.renderActions = (key, record) => {
      const editable = this.isEditing(key);
      const actions = [];

      if (editable) {
        actions.push( /*#__PURE__*/_react.default.createElement("span", {
          key: `${record.key}-save-cancel`
        }, /*#__PURE__*/_react.default.createElement("a", {
          onClick: () => this.save(key),
          style: {
            marginRight: 8
          }
        }, "Save"), /*#__PURE__*/_react.default.createElement(_popconfirm.default, {
          title: "Sure to cancel?",
          onConfirm: this.onCancel
        }, /*#__PURE__*/_react.default.createElement("a", null, "Cancel"))));
      } else {
        actions.push( /*#__PURE__*/_react.default.createElement(_typography.default.Link, {
          key: `${record.key}-edit`,
          disabled: this.state.editingKey !== '',
          onClick: () => this.onEdit(key)
        }, "Edit"));
      }

      if (this.props.rowActions) {
        actions.push(...this.props.rowActions(record.key).map((action, index) => /*#__PURE__*/_react.default.createElement("span", {
          key: `${record.key}-${index}`
        }, action)));
      }

      return actions;
    };

    this.rowClassName = (record, index) => index % 2 === 0 ? 'editable-row tr-even-color' : 'editable-row tr-odd-color';

    this.isEditing = key => {
      return this.state.editingKey === key;
    };

    this.onEdit = key => {
      const previousVersion = this.state.dataSource.find(a => a.key === key);
      this.setState({
        editingKey: key,
        previousVersion
      });
    };

    this.onCancel = () => {
      const {
        previousVersion,
        dataSource
      } = this.state;

      if (previousVersion) {
        // If previousVersion, revert to that and overwrite changes
        const newData = [...dataSource];
        const index = newData.findIndex(item => previousVersion.key === item.key);
        newData.splice(index, 1, previousVersion);
        this.setState({
          dataSource: newData
        });
      }

      this.setState({
        editingKey: '',
        previousVersion: undefined,
        isUnsaved: false
      });
    };

    this.columns = [...this.props.columns];

    if (!props.disabled) {
      this.columns.push({
        key: 'action-col',
        dataIndex: 'key',
        title: 'Action',
        render: this.renderActions
      });
    }

    this.state = {
      dataSource: this.props.dataSource || [],
      count: 2,
      editingKey: '',
      isUnsaved: false
    };
  }

  componentDidUpdate(prevProps) {
    if (!(0, _lodash.isEqual)(prevProps.dataSource, this.props.dataSource)) {
      this.setState({
        dataSource: this.props.dataSource || []
      });
    }

    if (!(0, _lodash.isEqual)(this.columns, this.props.columns)) {
      this.columns = [...this.props.columns];

      if (!this.props.disabled) {
        this.columns.push({
          key: 'action',
          dataIndex: 'key',
          title: 'Action',
          render: this.renderActions
        });
      }
    }
  }

  render() {
    const {
      dataSource,
      isUnsaved
    } = this.state;
    const {
      rowSelection
    } = this.props;
    const components = {
      body: {
        row: _EditableRow.default,
        cell: _EditableCell.default
      }
    };
    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }

      return { ...col,
        onCell: record => {
          const isEditing = this.isEditing(record.key);
          return {
            record,
            editable: isEditing,
            dataIndex: col.dataIndex,
            title: col.title,
            handleSaveCell: this.handleSaveCell,
            required: col.required,
            validator: col.validator,
            editRender: col.editRender
          };
        }
      };
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_table.default, {
      components: components,
      columns: columns,
      dataSource: dataSource,
      rowKey: this.props.rowKey,
      rowClassName: this.rowClassName,
      rowSelection: rowSelection,
      scroll: {
        x: 1280,
        y: 980
      },
      pagination: false
    }), /*#__PURE__*/_react.default.createElement(_UnsavedLeavingGuard.default, {
      when: isUnsaved,
      navigate: path => this.props.history.push(path),
      shouldBlockNavigation: () => isUnsaved
    }));
  }

}

var _default = (0, _reactRouter.withRouter)(EditableTable);

exports.default = _default;